<template>
  <ag-modal-container
    :title="$t('networkdiagram.title.createInstruction')"
    width="500px"
    class="text-center"
    @close="back"
  >
    <ag-dropzone
      color="primary"
      outlined
      @upload="uploadFile"
      v-text="$t('networkdiagram.fields.instruction.upload')"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        color="primary"
        class="ml-5"
        outlined
        @click="back"
        v-text="$t('general.cancel')"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import AgModalContainer from 'src/components/common/AgModalContainer'
import AgDropzone from 'src/components/common/AgDropzone'
import Repositories from 'src/repositories'
import { mapActions } from 'vuex'

export default {
  name: 'InstructionCreateContainer',
  components: {
    AgModalContainer,
    AgDropzone,
  },
  data: () => ({
    isValid: false,
    loading: false,
  }),
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    create () {

    },
    async uploadFile (file) {
      this.loading = true
      try {
        await Repositories.networkDiagram.instruction.post(file)
        this.showSuccessNotification(this.$t('networkdiagram.fields.success.instructionCreated'))
        this.back()
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
